const fonts = {
  family: 'Roboto, sans-serif',
  pageTitle: { size: '48px', mobileSize: '28px', weight: 900 },
  sectionTitle: { size: '32px', weight: 700 },
  body: { size: '16px', weight: 400 },
  button: { size: '18px', weight: 700 },
  smallButton: { size: '14px', weight: 700 },
};

export default fonts;
